export const expenseConfigReducerSelector = state => state.expenseConfigReducer;

export const expenseConfigSelector = state => state.expenseConfigReducer.expenseConfig;

export const expenseTypesSelector = state => state.expenseConfigReducer.expenseTypes;
